// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9943c6c6","509":"c3c3e0eb","739":"97a6a99d","740":"f9ce8175","787":"9b9b3e54","828":"452ca608","890":"3cbdaf7d","906":"ac2de4a2","914":"e1f76f9c","974":"ce4613a0"}[chunkId] + ".chunk.js";
};